export const properties = [
  {
    zh: '协议编码',
    en: 'Code',
    value: 'code',
    required: true,
    type: 'text'
  },
  {
    zh: '协议名称',
    en: 'Name',
    value: 'name',
    required: true,
    type: 'text'
  },
  {
    zh: '协议类型',
    en: 'Type',
    value: 'type',
    required: true,
    type: 'select',
    options: [
      {
        zh: '公有协议',
        en: 'Public',
        value: 'public'
      },
      {
        zh: '私有协议',
        en: 'Private',
        value: 'private'
      }
    ]
  },
  {
    zh: '采集间隔(s)',
    en: 'Interval(s)',
    value: 'intervalTime',
    required: true,
    type: 'select',
    options: [
      {
        zh: '10',
        en: '10',
        value: '10'
      },
      {
        zh: '30',
        en: '30',
        value: '30'
      },
      {
        zh: '60',
        en: '60',
        value: '60'
      },
      {
        zh: '180',
        en: '180',
        value: '180'
      },
      {
        zh: '300',
        en: '300',
        value: '300'
      },
      {
        zh: '600',
        en: '600',
        value: '600'
      }
    ]
  },
  {
    zh: '单次请求最大数据点',
    en: 'Points limit per request',
    value: 'pointLimit',
    required: true,
    type: 'text'
  },
  {
    zh: '采集超时(s)',
    en: 'Timeout(s)',
    value: 'timeout',
    required: true,
    type: 'number'
  },
  {
    zh: '重连次数',
    en: 'Retry Count',
    value: 'retryCnt',
    required: true,
    type: 'number'
  },
  {
    zh: '备注',
    en: 'Remark',
    value: 'remark',
    type: 'text'
  },
  {
    zh: '状态标志',
    en: 'Status Flag',
    value: 'statusFlag',
    type: 'select',
    options: [
      {
        zh: '关闭',
        en: 'Close',
        value: 0
      },
      {
        zh: '开启',
        en: 'Open',
        value: 1
      }
    ]
  }
]

export const ModbusRTUDataPoint = [
  {
    zh: '编码',
    en: 'Code',
    dataIndex: 'code',
    key: 'code',
    width: 200,
    scopedSlots: { customRender: 'code' },
    sortable: true,
    input: true
  },
  {
    zh: '名称(中)',
    en: 'Name(Chinese)',
    dataIndex: 'zh-CN',
    key: 'nameZ',
    width: 200,
    scopedSlots: { customRender: 'nameZ' },
    input: true
  },
  {
    zh: '名称(英)',
    en: 'Name(English)',
    dataIndex: 'en-US',
    key: 'nameE',
    width: 200,
    scopedSlots: { customRender: 'nameE' },
    input: true
  },
  // {
  //   title: '描述',
  //   dataIndex: 'description',
  //   key: 'description',
  //   width: 100,
  //   scopedSlots: { customRender: 'description' }
  // },
  {
    zh: '单位',
    en: 'Unit',
    dataIndex: 'unit',
    key: 'unit',
    width: 100,
    scopedSlots: { customRender: 'unit' }
  },
  {
    zh: '编码形式',
    en: 'Code Decimal ',
    dataIndex: 'codecType',
    key: 'codecType',
    width: 100,
    scopedSlots: { customRender: 'codecType' }
  },
  {
    zh: '统计类型',
    en: 'Statistic Type',
    dataIndex: 'statisticType',
    key: 'statisticType',
    width: 120,
    scopedSlots: { customRender: 'statisticType' }
  },
  {
    zh: '数据类型',
    en: 'Value Type',
    dataIndex: 'valueType',
    key: 'valueType',
    width: 180,
    scopedSlots: { customRender: 'valueType' }
  },
  {
    zh: "读功能码",
    en: "Read Control Code",
    dataIndex: "readControlCode",
    key: "readControlCode",
    scopedSlots: { customRender: "readControlCode" }
  },
  {
    zh: "写功能码",
    en: "Write Control Code",
    dataIndex: "writeControlCode",
    key: "writeControlCode",
    scopedSlots: { customRender: "writeControlCode" }
  },
  {
    zh: '读写模式',
    en: 'Read-write Mode',
    dataIndex: 'pointType',
    key: 'pointType',
    scopedSlots: {
      customRender: 'pointType'
    },
    width: 150
  },
  {
    zh: '开始地址',
    en: 'Start Address',
    dataIndex: 'startAddress',
    key: 'startAddress',
    width: 100,
    scopedSlots: { customRender: 'startAddress' },
    input: true,
    sortable: true
  },
  {
    zh: '数据长度',
    en: 'Register Count',
    dataIndex: 'registerCnt',
    key: 'registerCnt',
    width: 100,
    scopedSlots: { customRender: 'registerCnt' },
    sortable: true
  },
  {
    zh: '系数',
    en: 'Coefficient',
    dataIndex: 'coefficient',
    key: 'coefficient',
    width: 100,
    scopedSlots: { customRender: 'coefficient' },
    sortable: true
  },
  {
    zh: '解析方式',
    en: 'Byte Order',
    dataIndex: 'byteOrder',
    key: 'byteOrder',
    width: 200,
    scopedSlots: { customRender: 'byteOrder' }
  },
  {
    zh: '数据写入',
    en: 'Data Write',
    dataIndex: 'dataWrite',
    key: 'dataWrite',
    width: 100,
    scopedSlots: { customRender: 'dataWrite' }
  },
  {
    zh: '上下限',
    en: 'Range',
    dataIndex: 'range',
    key: 'range',
    width: 150,
    scopedSlots: { customRender: 'range' }
  },
  {
    zh: '数据等级',
    en: 'Data Level',
    dataIndex: 'dataLevel',
    key: 'dataLevel',
    width: 100,
    scopedSlots: { customRender: 'dataLevel' },
    sortable: true
  },
  {
    zh: '排序',
    en: 'Priority',
    dataIndex: 'priority',
    key: 'priority',
    width: 100,
    scopedSlots: { customRender: 'priority' },
    sortable: true
  },
  {
    zh: '开启监控',
    en: 'Monitor',
    dataIndex: 'read',
    key: 'read',
    width: 100,
    scopedSlots: { customRender: 'read' }
  },
  {
    zh: '状态标志',
    en: 'Status Flag',
    dataIndex: 'statusFlag',
    key: 'statusFlag',
    scopedSlots: { customRender: 'statusFlag' },
    width: 120
  }
  // {
  //   title: '操作',
  //   dataIndex: 'operation',
  //   key: 'operation',
  //   width: 450,
  //   scopedSlots: { customRender: 'operation' },
  //   fixed: 'right'
  // }
]

export const DLT6452007DataPoint = [
  {
    zh: '编码',
    en: 'Code',
    dataIndex: 'code',
    key: 'code',
    width: 150,
    scopedSlots: { customRender: 'code' },
    sortable: true,
    input: true
  },
  {
    zh: '名称(中)',
    en: 'Name(Chinese)',
    dataIndex: 'zh-CN',
    key: 'nameZ',
    width: 150,
    scopedSlots: { customRender: 'nameZ' },
    input: true
  },
  {
    zh: '名称(英)',
    en: 'Name(English)',
    dataIndex: 'en-US',
    key: 'nameE',
    width: 150,
    scopedSlots: { customRender: 'nameE' },
    input: true
  },
  // {
  //   title: '描述',
  //   dataIndex: 'description',
  //   key: 'description',
  //   width: '20%',
  //   scopedSlots: { customRender: 'description' }
  // },
  {
    zh: '单位',
    en: 'Unit',
    dataIndex: 'unit',
    key: 'unit',
    width: 150,
    scopedSlots: { customRender: 'unit' }
  },
  {
    zh: '统计类型',
    en: 'Statistic Type',
    dataIndex: 'statisticType',
    key: 'statisticType',
    width: 150,
    scopedSlots: { customRender: 'statisticType' }
  },
  {
    zh: '系数',
    en: 'Coefficient',
    dataIndex: 'coefficient',
    key: 'coefficient',
    width: 150,
    scopedSlots: { customRender: 'coefficient' },
    sortable: true
  },
  {
    zh: '编码形式',
    en: 'Code Decimal ',
    dataIndex: 'codecType',
    key: 'codecType',
    width: 100,
    scopedSlots: { customRender: 'codecType' }
  },
  {
    zh: '数据标识',
    en: 'Data Mark',
    dataIndex: 'dataMark',
    key: 'dataMark',
    width: 150,
    scopedSlots: { customRender: 'dataMark' }
  },
  {
    zh: '数据写入',
    en: 'Data Write',
    dataIndex: 'dataWrite',
    key: 'dataWrite',
    width: 150,
    scopedSlots: { customRender: 'dataWrite' }
  },
  {
    zh: '读写模式',
    en: 'Read-write Mode',
    dataIndex: 'pointType',
    key: 'pointType',
    scopedSlots: {
      customRender: 'pointType'
    },
    width: 150
  },
  {
    zh: '数据等级',
    en: 'Data Level',
    dataIndex: 'dataLevel',
    key: 'dataLevel',
    width: 150,
    scopedSlots: { customRender: 'dataLevel' },
    sortable: true
  },
  {
    zh: '开启监控',
    en: 'Monitor',
    dataIndex: 'read',
    key: 'read',
    width: 150,
    scopedSlots: { customRender: 'read' }
  },
  {
    zh: '上下限',
    en: 'Range',
    dataIndex: 'range',
    key: 'range',
    width: 210,
    scopedSlots: { customRender: 'range' }
  },
  {
    zh: '排序',
    en: 'Priority',
    dataIndex: 'priority',
    key: 'priority',
    width: 150,
    scopedSlots: { customRender: 'priority' },
    sortable: true
  },
  {
    zh: '状态标志',
    en: 'Status Flag',
    dataIndex: 'statusFlag',
    key: 'statusFlag',
    scopedSlots: { customRender: 'statusFlag' },
    width: 120
  }
  // {
  //   title: '操作',
  //   dataIndex: 'operation',
  //   key: 'operation',
  //   width: 450,
  //   scopedSlots: { customRender: 'operation' },
  //   fixed: 'right'
  // }
]

export const rulesFormItems = [
  {
    span: 4,
    type: 'select',
    options: {
      'EQ': '=',
      'NE': '≠',
      'LT': '<',
      'LE': '≤',
      'GT': '>',
      'GE': '≥'
    },
    dataIndex: 'match',
    placeholder: '请选择匹配符'
  },
  {
    span: 5,
    type: 'text',
    dataIndex: 'targetValue',
    placeholder: '请输入目标值'
  },
  {
    span: 5,
    type: 'text',
    dataIndex: 'value',
    placeholder: '请输入显示值'
  },
  {
    span: 8,
    type: 'text',
    placeholder: '请输入状态标记',
    dataIndex: 'tag'
  }
]

export const bitFormItems = [
  {
    span: 3,
    type: 'text',
    placeholder: '请输入位号',
    dataIndex: 'pos'
  },
  {
    span: 5,
    type: 'text',
    placeholder: '请输入名称',
    dataIndex: 'name'
  },
  {
    span: 3,
    type: 'text',
    placeholder: '0',
    dataIndex: 'zero'
  },
  {
    span: 3,
    type: 'text',
    placeholder: '1',
    dataIndex: 'one'
  },
  {
    span: 8,
    type: 'text',
    placeholder: '请输入状态标记',
    dataIndex: 'tag'
  }
]